import { LoopFetchProductResult } from '@ts/loopFetchProductResult';
import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

export default function useVariant(product: LoopFetchProductResult) {
  const searchParams = useSearchParams();
  return useMemo(() => {
    if (product.variants.length === 1) {
      return product.variants[0];
    }
    if (searchParams.has('variant')) {
      return product.variants?.find(
        (variant) => variant.id === searchParams.get('variant'),
      );
    }
    return undefined;
  }, [searchParams, product.variants]);
}
